import type { ReactNode } from "react";
import { useEffect, useRef, useState } from "react";

import type { SnackType, SnackPosition } from "../LegacySnackbarContext";
import { LegacySnackbarContext } from "../LegacySnackbarContext";

interface Props {
  /**
   * Content to render
   *
   * @default undefined
   */
  children?: ReactNode;
}

/**
 * @deprecated Use the `useSnackbar` hook from `@fullscript/aviary-web` instead
 */
const LegacySnackWrap = ({ children }: Props) => {
  const [isSnackbarOpen, setSnackbarIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<SnackType>("normal");
  const [position, setPosition] = useState<SnackPosition>("bottomLeft");

  const timeout = useRef<number>(undefined);

  const setSnackbarState = (
    newStatus: SnackType,
    newMessage: string,
    isOpen: boolean,
    newPosition?: SnackPosition
  ) => {
    setStatus(newStatus);
    setMessage(newMessage);
    setSnackbarIsOpen(isOpen);
    setPosition(newPosition || "bottomLeft");
  };

  useEffect(() => {
    return () => clearTimeout(timeout.current);
  }, []);

  const setSnackMessage = (
    newStatus: SnackType,
    newMessage: string,
    newPosition?: SnackPosition
  ) => {
    clearTimeout(timeout.current);
    setSnackbarState(newStatus, newMessage, true, newPosition);
  };

  const closeSnack = (newMessage: string, noDelay?: boolean) => {
    if (noDelay) {
      setSnackbarState("normal", newMessage, false, position);
    } else {
      setSnackbarState("normal", newMessage, true, position);
      timeout.current = window.setTimeout(() => {
        setSnackbarState("normal", newMessage, false, position);
      }, 600);
    }
  };

  return (
    <LegacySnackbarContext
      value={{
        isSnackbarOpen,
        closeSnack,
        message,
        status,
        setSnackMessage,
        position,
      }}
    >
      {children}
    </LegacySnackbarContext>
  );
};

export { LegacySnackWrap };
